import {SerializedStyles} from '@emotion/react/dist/emotion-react.cjs';
import {useTheme, css} from '@mui/material';
import {GetStylesFunction} from '@wallaby-ui/core';
import React from 'react';

interface OwnProps {
  listKey?: string;
  isNavigationOpen: boolean;
  inputCss?: SerializedStyles;
}

type Props = OwnProps;

export const NavigationBoxDivider: React.FC<Props> = (props) => {
  const {listKey, isNavigationOpen, inputCss} = props;
  const theme = useTheme();

  const styles = getStyles({
    theme,
    params: {inList: listKey !== undefined, isNavigationOpen, inputCss},
  });

  return (
    <div data-name={'navigation-box-divider--wrapper'} css={styles.dividerWrapper}>
      <div
        data-name={'navigation-box-divider--animated'}
        key={`navigation.divider.${listKey}`}
        css={styles.divider}
        style={{
          width: 'calc(100% - 32px)',
        }}
      />
    </div>
  );
};

NavigationBoxDivider.displayName = 'NavigationBoxDivider';

const getStyles: GetStylesFunction = (options) => ({
  dividerWrapper: css`
    height: 40px;
    display: ${options?.params?.isNavigationOpen ? 'none' : 'flex'};
    justify-content: center;
    align-items: center;
    align-self: center;
    ${options?.params?.inputCss ?? ''};
  `,
  divider: css`
    height: 1px;
    background: ${options?.theme?.palette.custom.dividerBorderColor as string};
    position: relative;
  `,
});
